import React from "react";

const LargeText: React.FC<{ class?: string }> = props => {
  return <span className={`text-lg  text-center ${props?.class}`}>{props?.children}</span>;
};

export default LargeText;
